import Image from 'next/image';
import PropTypes from 'prop-types';

import {Text} from '../../ui';
import css from '../styles/TargetUserSearchFilterLayout.module.css';

const TargetUserSearchFilterLayout = ({onClearClick, firstName, lastName}) => {
  return (
    <div className={css.label}>
      <div className={css.fullName}>
        <Text
          color={Text.COLOR.WHITE}
          fontSize={Text.FONT_SIZE.SIZE_16}
          fontWeight={Text.FONT_WEIGHT.BOLD}
          isOneLine={true}
        >
          {`${firstName} ${lastName}`}
        </Text>
      </div>
      <div className={css.closeIcon} onClick={onClearClick}>
        <Image
          src={`/icons/whiteCloseIcon.svg`}
          loading="lazy"
          alt="true"
          width="11"
          height="11"
        />
      </div>
    </div>
  );
};

TargetUserSearchFilterLayout.propTypes = {
  onClearClick: PropTypes.func.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
};

export default TargetUserSearchFilterLayout;
